import React from 'react';
const stats = [{
  value: '+500',
  label: 'Lehrer & Trainer',
  color: 'text-[#FF6B00]'
}, {
  value: '6+5',
  label: 'Bände + Boni',
  color: 'text-[#FF6B00]'
}, {
  value: '4.9/5',
  label: 'Bewertung ⭐',
  color: 'text-[#FF6B00]'
}, {
  value: '🌍',
  label: 'DACH-Region',
  color: 'text-[#0A0A0A]'
}];
const testimonials = [{
  quote: 'Ich habe mein gesamtes Schuljahr an einem einzigen Abend geplant. Jede Stunde hat jetzt ein klares Ziel – meine Schüler lieben es.',
  name: 'Jonas R.',
  role: 'Sportlehrer'
}, {
  quote: 'Keine YouTube-Suche mehr am Sonntagabend. Ich öffne das PDF und bin bereit. Ein absoluter Game Changer für meine Zeit.',
  name: 'Sarah L.',
  role: 'Basketballtrainerin'
}, {
  quote: 'Endlich eine logische Progression. Meine Teams spielen besser denn je und die Planung dauert nur noch Minuten.',
  name: 'Markus T.',
  role: 'Jugendtrainer'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white py-12 px-4 border-b border-[#E5E5EA]" data-id="element-191">
      <div className="max-w-5xl mx-auto" data-id="element-192">
        <div className="flex flex-wrap items-center justify-around gap-6 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl px-6 py-6 mb-10 shadow-sm" data-id="element-193">
          {stats.map((s, i) => <div key={i} className="text-center min-w-[100px]" data-id="element-194">
              <div className={`text-3xl sm:text-4xl font-black ${s.color} tracking-tight`} data-id="element-195">
                {s.value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold mt-1 uppercase tracking-wider" data-id="element-196">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-197">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-198">
              <div className="text-[#FFD700] text-lg mb-3" data-id="element-199">⭐⭐⭐⭐⭐</div>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-medium italic flex-1 mb-4 leading-relaxed" data-id="element-200">
                "{t.quote}"
              </p>
              <div data-id="element-201">
                <div className="font-black text-[#0A0A0A] text-sm" data-id="element-202">
                  {t.name}
                </div>
                <div className="text-[#5A5A66] text-xs font-semibold" data-id="element-203">
                  {t.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}